(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3215],{

/***/ 23215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-if/dist/react-if.esm.js
var react_if_esm = __webpack_require__(34394);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/mobx-react-lite/es/index.js + 13 modules
var es = __webpack_require__(46670);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./components/Card/card.module.sass
var card_module = __webpack_require__(75829);
var card_module_default = /*#__PURE__*/__webpack_require__.n(card_module);
// EXTERNAL MODULE: ./components/Icon/index.js + 1 modules
var Icon = __webpack_require__(85708);
// EXTERNAL MODULE: ./components/Badge/index.js + 1 modules
var Badge = __webpack_require__(92558);
// EXTERNAL MODULE: ./utils/formatter.js
var formatter = __webpack_require__(88091);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./utils/isClient.js
var isClient = __webpack_require__(69594);
// EXTERNAL MODULE: ./providers/RootStoreProvider.jsx + 49 modules
var RootStoreProvider = __webpack_require__(8710);
// EXTERNAL MODULE: ./hooks/useEmblaSlider.js
var useEmblaSlider = __webpack_require__(21471);
// EXTERNAL MODULE: ./components/TravelTime/index.js + 1 modules
var TravelTime = __webpack_require__(7824);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./components/CruiseRoute/cruiseroute.module.sass
var cruiseroute_module = __webpack_require__(31127);
var cruiseroute_module_default = /*#__PURE__*/__webpack_require__.n(cruiseroute_module);
// EXTERNAL MODULE: ./utils/declOfNum.js
var declOfNum = __webpack_require__(5547);
;// CONCATENATED MODULE: ./components/CruiseRoute/CruiseRoute.jsx







// [**, *, *, *, *, *, *, *, **]
var makeBetweenBold = function(items) {
    return items.map(function(i, index, param) {
        var length = param.length;
        // Добавляем первому и последнему элементу жирность
        if (index === 0 || index === length - 1) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (cruiseroute_module_default()).bold,
                children: i
            });
        }
        return i;
    });
};
var makeSimpleList = function(items) {
    return items.split(" – ").map(function(i, index, param) {
        var length = param.length;
        if (index === 0 || index === length - 1) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (cruiseroute_module_default()).bold,
                children: i
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: i
        });
    }).reduce(function(prev, curr) {
        return [
            prev,
            " – ",
            curr
        ];
    });
};
var CruiseRoute = function(param) {
    var className = param.className, _items = param.items, items = _items === void 0 ? [] : _items, _noReturn = param.noReturn, noReturn = _noReturn === void 0 ? false : _noReturn, _separator = param.separator, separator = _separator === void 0 ? " – " : _separator, limit = param.limit, _boldBetween = param.boldBetween, boldBetween = _boldBetween === void 0 ? true : _boldBetween, onShowMore = param.onShowMore, _simpleView = param.simpleView, simpleView = _simpleView === void 0 ? false : _simpleView;
    if (items.length < 1) return null;
    var generateList = function() {
        var arr = items.split(separator);
        var length = arr.length;
        var res = boldBetween ? makeBetweenBold(arr) : arr;
        if (limit && onShowMore && length - 2 - 1 > limit) {
            var _build;
            var build = [];
            var betweenBoldValues = res.slice(1, res.length - 2);
            var limited = betweenBoldValues.slice(0, limit);
            var directionCount = betweenBoldValues.length - limit + 1;
            (_build = build).push.apply(_build, [
                res[0]
            ].concat((0,_to_consumable_array/* default */.Z)(limited)));
            build.push(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                role: "button",
                tabIndex: "0",
                className: (cruiseroute_module_default()).btn,
                onClick: onShowMore,
                onKeyDown: onShowMore,
                children: [
                    "Показать еще ",
                    directionCount,
                    " ",
                    (0,declOfNum/* declOfNum */.A)(directionCount, [
                        "направление",
                        "направления",
                        "направлений", 
                    ])
                ]
            }));
            build.push(res[length - 1]);
            return build;
        }
        return res;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: (0,classcat/* default */.Z)((0,_define_property/* default */.Z)({}, className, !!className)),
        children: [
            simpleView ? makeSimpleList(items) : generateList().reduce(function(prev, curr) {
                return [
                    prev,
                    separator,
                    curr
                ];
            }),
            noReturn && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (cruiseroute_module_default()).noReturn,
                children: "\xa0(без возвращения)"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/CruiseRoute/index.js


// EXTERNAL MODULE: ./lib/YaAndGaHelper.js + 2 modules
var YaAndGaHelper = __webpack_require__(38214);
// EXTERNAL MODULE: ./components/Modal/index.js
var Modal = __webpack_require__(178);
// EXTERNAL MODULE: ./utils/reworkUrl.js
var reworkUrl = __webpack_require__(31181);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
// EXTERNAL MODULE: ./components/Image/Image.jsx
var Image = __webpack_require__(49028);
// EXTERNAL MODULE: ./utils/useFormatDate.js
var useFormatDate = __webpack_require__(14971);
// EXTERNAL MODULE: ./lib/yandexDataLayer.js
var yandexDataLayer = __webpack_require__(12406);
// EXTERNAL MODULE: ./providers/SearchStoreProvider.tsx + 5 modules
var SearchStoreProvider = __webpack_require__(27101);
// EXTERNAL MODULE: ./utils/isBlackFridayCheck.js
var isBlackFridayCheck = __webpack_require__(66373);
// EXTERNAL MODULE: ./lib/sendVKPixelEvent.js
var sendVKPixelEvent = __webpack_require__(13866);
;// CONCATENATED MODULE: ./components/Card/Card.jsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 











// import { declOfNum } from '../../utils/declOfNum';
















var CruiseRouteMap = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9269), __webpack_require__.e(7912)]).then(__webpack_require__.bind(__webpack_require__, 29535));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29535)
            ];
        }
    },
    ssr: false
});
var categories = {
    1: {
        classCategoryReady: "eco",
        title: "Эконом"
    },
    2: {
        classCategoryReady: "standart",
        title: "Стандарт"
    },
    3: {
        classCategoryReady: "comfort",
        title: "Комфорт"
    },
    6: {
        classCategoryReady: "lux",
        title: "Люкс"
    },
    7: {
        classCategoryReady: "premium",
        title: "Премиум"
    }
};
var categoriesStr = {
    Эконом: {
        classCategoryReady: "eco",
        title: "Эконом"
    },
    Стандарт: {
        classCategoryReady: "standart",
        title: "Стандарт"
    },
    Комфорт: {
        classCategoryReady: "comfort",
        title: "Комфорт"
    },
    Люкс: {
        classCategoryReady: "lux",
        title: "Люкс"
    },
    Премиум: {
        classCategoryReady: "premium",
        title: "Премиум"
    }
};
var preparingImages = function(images) {
    if (!(images === null || images === void 0 ? void 0 : images.length)) return [];
    return images;
};
var Card = (0,es/* observer */.Pi)(function(param) {
    var index = param.index, id = param.id, _title = param.title, title = _title === void 0 ? "" : _title, link = param.link, price = param.price, route = param.route, shipId = param.shipId, cashback = param.cashback, places = param.places, category = param.category, categoryTitle = param.categoryTitle, popdir = param.popdir, startDate = param.startDate, endDate = param.endDate, start = param.start, end = param.end, oldPrice = param.oldPrice, isFavorities = param.isFavorities, days = param.days, night = param.night, specialNote = param.specialNote, discounts = param.discounts, categoryString = param.categoryString, isSpecialOffer = param.isSpecialOffer, specialOfferValue = param.specialOfferValue, company = param.company, sea = param.sea, viewed = param.viewed, _images = param.images, images = _images === void 0 ? [] : _images, isMobile = param.isMobile, isShipCard = param.isShipCard, // countDesc,
    seat_count = param.seat_count, caute_count = param.caute_count, blackFriday = param.blackFriday, // shopingBadge,
    // snowBadge,
    onClick = param.onClick, tour = param.tour, turField = param.turField, recomend = param.recomend, popularCruises = param.popularCruises, metriks = param.metriks, url = param.url, direction = param.direction, ownerId = param.ownerId;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useState)(0), activeImage = ref5[0], setActiveImage = ref5[1];
    var ref6 = (0,react.useState)(false), routeModalIsOpen = ref6[0], setRouteModalIsOpen = ref6[1];
    var favorite = (0,RootStoreProvider/* useFavorites */.rc)();
    var ref7 = (0,useEmblaSlider/* useEmblaSlider */.r)(), ref8 = ref7.ref, current = ref7.current;
    var dateStart = (0,useFormatDate/* formatDateStart */.yk)(startDate, endDate);
    var dateEnd = (0,useFormatDate/* formatDateEnd */.fc)(endDate);
    var ships = [
        191,
        91,
        403,
        71,
        30,
        66,
        197,
        199,
        211,
        208,
        431,
        204,
        434,
        409, 
    ];
    var dateOptions = {
        weekday: "short",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        timeZoneName: "long"
    };
    var preparedFavoriteData = {
        id: id,
        title: title,
        price: price,
        route: route,
        places: places,
        images: images,
        category: categoryString ? category : (ref = categories[category]) === null || ref === void 0 ? void 0 : ref.title,
        startDate: startDate,
        endDate: endDate,
        special_note: specialNote,
        kr_days: days,
        ship_id: shipId,
        isSea: Boolean(sea)
    };
    var isFavorite = favorite.checkById(id);
    var onFavorite = function(e) {
        favorite.toggle(preparedFavoriteData);
        e.stopPropagation();
    };
    var urlPopdir = direction ? "?".concat(direction) : "";
    var str = categoryString ? categoriesStr : categories;
    var href = sea ? "/sea_cruise/".concat(link).concat(urlPopdir) : "/cruise/".concat(link).concat(urlPopdir);
    href = isShipCard ? "/ships/".concat(link).concat(urlPopdir) : href;
    var imageLinks = !isShipCard ? preparingImages(images) : images;
    var allowedImagesNumber = 5;
    var imagesLeft = imageLinks.length - allowedImagesNumber;
    var totalZones = imageLinks.length > allowedImagesNumber ? allowedImagesNumber : imageLinks.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (card_module_default()).wrapper,
        onClick: function() {
            return (0,yandexDataLayer/* yandexDataLayer */.qu)("click", {
                id: id,
                name: "".concat(title, " с ").concat(dateStart, " по ").concat(dateEnd),
                brand: company,
                category: "".concat(sea ? "Море" : "Река", "/").concat(categoryTitle, "/").concat(title, "/").concat(route),
                list: popdir === null || popdir === void 0 ? void 0 : popdir.caption,
                position: index + 1,
                price: price,
                quantity: 1
            });
        },
        children: [
            isClient/* isClient */.C && !isShipCard && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: (card_module_default()).favorite,
                onClick: onFavorite,
                title: "Корзина",
                children: !isFavorite ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                    name: url === "black_friday" ? "common/cartBf" : "common/cart",
                    width: 36,
                    height: 36,
                    title: "Корзина",
                    onClick: function() {
                        (0,yandexDataLayer/* yandexDataLayer */.qu)("add", {
                            id: id,
                            name: "".concat(title, " с ").concat(dateStart, " по ").concat(dateEnd),
                            brand: company,
                            category: "".concat(sea ? "Море" : "Река", "/").concat(categoryTitle, "/").concat(title, "/").concat(route),
                            list: popdir === null || popdir === void 0 ? void 0 : popdir.caption,
                            position: index + 1,
                            price: price,
                            quantity: 1
                        });
                        (0,sendVKPixelEvent/* sendVKPixelEvent */.c)("AddToCart", {
                            product_id: id,
                            value: price
                        });
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                    name: url === "black_friday" ? "common/cartBf-active" : "common/cart-active",
                    width: 24,
                    height: 24,
                    title: "Добавлено в корзину",
                    onClick: function() {
                        return (0,yandexDataLayer/* yandexDataLayer */.qu)("remove", {
                            id: id,
                            name: "".concat(title, " с ").concat(dateStart, " по ").concat(dateEnd),
                            brand: company,
                            category: "".concat(sea ? "Море" : "Река", "/").concat(categoryTitle, "/").concat(title, "/").concat(route),
                            list: popdir === null || popdir === void 0 ? void 0 : popdir.caption,
                            position: index + 1,
                            price: price,
                            quantity: 1
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    !isShipCard && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        itemScope: true,
                        itemType: "http://schema.org/SaleEvent",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                itemProp: "startDate",
                                content: new Date(dayjs_min_default()(startDate).format("YYYY,MM,DD")).toLocaleDateString("ru-Ru", dateOptions)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                itemProp: "endDate",
                                content: new Date(dayjs_min_default()(endDate).format("YYYY,MM,DD")).toLocaleDateString("ru-Ru", dateOptions)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                itemProp: "name",
                                content: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                itemProp: "description",
                                content: "Круиз.онлайн"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                itemProp: "eventAttendanceMode",
                                content: "https://schema.org/OnlineEventAttendanceMode"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                itemProp: "eventStatus",
                                content: "https://schema.org/EventScheduled"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                itemProp: "url",
                                content: "/cruise/".concat(id)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                itemProp: "image",
                                content: images && ((ref1 = images[0]) === null || ref1 === void 0 ? void 0 : ref1.srcset)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                itemProp: "performer",
                                content: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                itemScope: true,
                                itemType: "http://schema.org/Place",
                                itemProp: "location",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                        itemProp: "logo",
                                        content: "Круиз.онлайн"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                        itemProp: "name",
                                        content: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        itemProp: "address",
                                        itemScope: true,
                                        itemType: "http://schema.org/PostalAddress",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                                itemProp: "url",
                                                content: "/cruise/".concat(id)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                                itemProp: "streetAddress",
                                                content: "Галактионовская ул., 157"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                                itemProp: "addressLocality",
                                                content: "Самара"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                                itemProp: "postalCode",
                                                content: "443041"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                                itemProp: "addressRegion",
                                                content: "RU"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                                itemProp: "addressCountry",
                                                content: "RU"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                itemProp: "offers",
                                itemScope: true,
                                itemType: "https://schema.org/Offer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                        itemProp: "price",
                                        content: price
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                        itemProp: "priceCurrency",
                                        content: "RUB"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                        itemProp: "url",
                                        content: "/cruise/".concat(id)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                        itemProp: "availability",
                                        href: "https://schema.org/InStock"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                        itemProp: "validFrom",
                                        content: new Date(dayjs_min_default()(startDate).format("YYYY,MM,DD")).toLocaleDateString("ru-Ru", dateOptions)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                itemProp: "organizer",
                                content: "Круиз.онлайн",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                    itemProp: "url",
                                    content: "/"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (card_module_default()).main,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: href,
                                ref: ref8,
                                className: (card_module_default()).link,
                                rel: "noreferrer",
                                onClick: onClick ? function() {
                                    (0,YaAndGaHelper/* YaAndGaMainPage */.gh)("click_choose_cabin");
                                    (0,yandexDataLayer/* yandexDataLayer */.qu)("click", {
                                        id: id,
                                        name: "".concat(title, " с ").concat(dateStart, " по ").concat(dateEnd),
                                        brand: company,
                                        category: "".concat(sea ? "Море" : "Река", "/").concat(categoryTitle, "/").concat(title, "/").concat(route),
                                        list: popdir === null || popdir === void 0 ? void 0 : popdir.caption,
                                        position: index + 1,
                                        price: price,
                                        quantity: 1
                                    });
                                } : function() {
                                    return (0,yandexDataLayer/* yandexDataLayer */.qu)("click", {
                                        id: id,
                                        name: "".concat(title, " с ").concat(dateStart, " по ").concat(dateEnd),
                                        brand: company,
                                        category: "".concat(sea ? "Море" : "Река", "/").concat(categoryTitle, "/").concat(title, "/").concat(route),
                                        list: popdir === null || popdir === void 0 ? void 0 : popdir.caption,
                                        position: index + 1,
                                        price: price,
                                        quantity: 1
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                    className: (card_module_default()).header,
                                    children: title || "-"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (card_module_default()).pic,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_if_esm.If, {
                                        condition: (images === null || images === void 0 ? void 0 : images.length) < 2,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Then */.Zf, {
                                                children: imageLinks.slice(0, allowedImagesNumber).map(function(i, index) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                                                        href: href,
                                                        className: (card_module_default()).embla,
                                                        ref: ref8,
                                                        rel: "noreferrer",
                                                        onClick: onClick !== null && onClick !== void 0 ? onClick : function() {
                                                            (0,yandexDataLayer/* yandexDataLayer */.qu)("click", {
                                                                id: id,
                                                                name: "".concat(title, " с ").concat(dateStart, " по ").concat(dateEnd),
                                                                brand: company,
                                                                category: "".concat(sea ? "Море" : "Река", "/").concat(categoryTitle, "/").concat(title, "/").concat(route),
                                                                list: popdir === null || popdir === void 0 ? void 0 : popdir.caption,
                                                                position: index + 1,
                                                                price: price,
                                                                quantity: 1
                                                            });
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                            src: (0,reworkUrl/* ReworkUrl */.$)(i.src),
                                                            srcSet: (0,reworkUrl/* ReworkUrl */.$)(i.srcset),
                                                            className: (0,classcat/* default */.Z)((0,_define_property/* default */.Z)({}, (card_module_default()).blackout, viewed)),
                                                            alt: title,
                                                            loading: "lazy",
                                                            style: {
                                                                display: index === activeImage ? "block" : "none"
                                                            }
                                                        }, index)
                                                    });
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Else */.Ot, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_if_esm.If, {
                                                    condition: isMobile,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Then */.Zf, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: href,
                                                                className: (card_module_default()).embla,
                                                                ref: ref8,
                                                                rel: "noreferrer",
                                                                onClick: onClick !== null && onClick !== void 0 ? onClick : function() {
                                                                    return (0,yandexDataLayer/* yandexDataLayer */.qu)("click", {
                                                                        id: id,
                                                                        name: "".concat(title, " с ").concat(dateStart, " по ").concat(dateEnd),
                                                                        brand: company,
                                                                        category: "".concat(sea ? "Море" : "Река", "/").concat(categoryTitle, "/").concat(title, "/").concat(route),
                                                                        list: popdir === null || popdir === void 0 ? void 0 : popdir.caption,
                                                                        position: index + 1,
                                                                        price: price,
                                                                        quantity: 1
                                                                    });
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (card_module_default()).emblaContainer,
                                                                    children: imageLinks.slice(0, allowedImagesNumber).map(function(i, index) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (0,classcat/* default */.Z)([
                                                                                (card_module_default()).emblaSlide,
                                                                                (0,_define_property/* default */.Z)({}, (card_module_default()).blackout, viewed), 
                                                                            ]),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                                                src: sea ? "".concat(i.src) : (0,reworkUrl/* ReworkUrl */.$)(i.src),
                                                                                srcSet: sea ? "".concat(i.srcset) : (0,reworkUrl/* ReworkUrl */.$)(i.srcset),
                                                                                alt: title,
                                                                                loading: index === 0 ? "eager" : "lazy"
                                                                            })
                                                                        }, index);
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Else */.Ot, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                style: {
                                                                    height: "100%"
                                                                },
                                                                className: (0,classcat/* default */.Z)((0,_define_property/* default */.Z)({}, (card_module_default()).blackout, viewed)),
                                                                children: imageLinks.slice(0, allowedImagesNumber).map(function(i, index) {
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                                        src: recomend ? "".concat(i.src) : (0,reworkUrl/* ReworkUrl */.$)(i.src),
                                                                        srcSet: recomend ? "".concat(i.srcset) : (0,reworkUrl/* ReworkUrl */.$)(i.srcset),
                                                                        className: (0,classcat/* default */.Z)((0,_define_property/* default */.Z)({}, (card_module_default()).blackout, viewed)),
                                                                        alt: i.description ? i.description : title,
                                                                        title: i.description ? i.description : title,
                                                                        loading: "lazy",
                                                                        style: {
                                                                            display: index === activeImage ? "block" : "none"
                                                                        }
                                                                    }, index);
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (card_module_default()).badges,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (card_module_default()).bagesBlock,
                                                children: [
                                                    (0,isBlackFridayCheck/* genderHoliday */.h)() && ships.includes(shipId) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                                        view: "newYear",
                                                        size: "smUltra",
                                                        icon: "marchHolliday",
                                                        children: "Скидка к 8 марта!"
                                                    }),
                                                    !sea && category && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                                        size: "smUltra",
                                                        view: (ref2 = str[category]) === null || ref2 === void 0 ? void 0 : ref2.classCategoryReady,
                                                        icon: (ref3 = str[category]) === null || ref3 === void 0 ? void 0 : ref3.classCategoryReady,
                                                        children: (ref4 = str[category]) === null || ref4 === void 0 ? void 0 : ref4.title
                                                    })
                                                ]
                                            }),
                                            !sea && tour !== 0 && tour !== undefined && tour !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                                view: "tour",
                                                size: "smUltra",
                                                icon: "tour",
                                                children: turField || "Круиз + тур"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm.If, {
                                        condition: totalZones > 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_if_esm/* Then */.Zf, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm.If, {
                                                    condition: !isMobile,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Then */.Zf, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: href,
                                                            className: (card_module_default()).zones,
                                                            onMouseLeave: function() {
                                                                return setActiveImage(0);
                                                            },
                                                            rel: "noreferrer",
                                                            children: new Array(totalZones).fill(0).map(function(_, index) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (card_module_default()).zone,
                                                                    onMouseOver: function() {
                                                                        return setActiveImage(index);
                                                                    },
                                                                    onFocus: function() {
                                                                        return setActiveImage(index);
                                                                    }
                                                                }, index);
                                                            })
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (card_module_default()).dots,
                                                    children: new Array(totalZones).fill(0).map(function(_, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: (0,classcat/* default */.Z)([
                                                                (card_module_default()).dot,
                                                                (0,_define_property/* default */.Z)({}, (card_module_default()).active, index === (isMobile ? current : activeImage)), 
                                                            ])
                                                        }, index);
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm.If, {
                                                    condition: (isMobile ? current : activeImage) + 1 === allowedImagesNumber && imagesLeft > 0,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_if_esm/* Then */.Zf, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (card_module_default()).morePhotos,
                                                            children: [
                                                                "Ещё ",
                                                                imagesLeft,
                                                                " фото"
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    viewed && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (card_module_default()).viewed,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* Badge */.C, {
                                            view: "white",
                                            size: "smUltra",
                                            children: "Просмотрено"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (card_module_default()).body,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CruiseRoute, {
                                        simpleView: true,
                                        limit: 2,
                                        items: route,
                                        noReturn: start !== end,
                                        onShowMore: function() {
                                            setRouteModalIsOpen(true);
                                        }
                                    }),
                                    !isShipCard && dateStart && dateEnd && /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelTime/* TravelTime */.R, {
                                        start: dateStart,
                                        end: dateEnd,
                                        days: days,
                                        nights: night
                                    }),
                                    specialNote && !(specialNote === null || specialNote === void 0 ? void 0 : specialNote.includes("15%")) && specialNote !== "Распродажа зимних круизов!" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (card_module_default()).bonus,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                    name: "promo/note",
                                                    width: 24,
                                                    height: 24
                                                }),
                                                rightGap: 8,
                                                title: "Спец предложение"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: specialNote
                                            })
                                        ]
                                    }),
                                    isSpecialOffer !== 0 && isSpecialOffer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (card_module_default()).bonus,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                    name: "promo/present",
                                                    width: 24,
                                                    height: 24
                                                }),
                                                rightGap: 8,
                                                title: "Спец предложение"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Спецпредложение -",
                                                    specialOfferValue,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: discounts != null && Object.values(discounts).map(function(discount) {
                                            return discount != null && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (card_module_default()).modalDiscounts,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                            name: "promo/sale",
                                                            width: 24,
                                                            height: 24
                                                        }),
                                                        rightGap: 8,
                                                        title: "Скидка"
                                                    }),
                                                    discount.value,
                                                    "% ",
                                                    discount.alias
                                                ]
                                            }, discount.value);
                                        })
                                    }),
                                    (0,isBlackFridayCheck/* isNewYear */.m)() && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (card_module_default()).bonus,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                    name: "promo/violetPresent",
                                                    width: 24,
                                                    height: 24
                                                }),
                                                rightGap: 8,
                                                title: "Спец предложение"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Выигрывайте кешбэк до 20%"
                                            })
                                        ]
                                    }),
                                    cashback === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (card_module_default()).bonus,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                    name: "promo/cashback",
                                                    width: 24,
                                                    height: 24
                                                }),
                                                rightGap: 8,
                                                title: "Иконка кэшбека"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Кэшбэк 20%"
                                            })
                                        ]
                                    }),
                                    isShipCard && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (card_module_default()).bonus,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                            name: "promo/caute_count",
                                                            width: 24,
                                                            height: 24
                                                        }),
                                                        rightGap: 8,
                                                        title: "Иконка кэшбека"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            "Общее количество кают: ",
                                                            caute_count
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (card_module_default()).bonus,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                                            name: "promo/seat_count",
                                                            width: 24,
                                                            height: 24
                                                        }),
                                                        rightGap: 8,
                                                        title: "Иконка кэшбека"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            "Вместимость (человек): ",
                                                            seat_count
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                className: (card_module_default()).footer,
                children: [
                    !isShipCard && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (card_module_default()).footerPrice,
                        children: [
                            price < 200 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (card_module_default()).priceInfo,
                                children: "цена по запросу"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (card_module_default()).price,
                                children: "от ".concat((0,formatter/* formatter */.z)(price), " ₽")
                            }),
                            oldPrice !== price && !isFavorities && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (card_module_default()).price,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (card_module_default()).oldPrice,
                                    children: sea && !price && oldPrice < 200 ? "цена по запросу" : "от ".concat((0,formatter/* formatter */.z)(oldPrice), " ₽")
                                })
                            })
                        ]
                    }),
                    !isShipCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: href,
                            className: url === "black_friday" ? (card_module_default()).btnBf : (card_module_default()).btn,
                            onClick: onClick !== null && onClick !== void 0 ? onClick : function() {
                                return [
                                    (0,yandexDataLayer/* yandexDataLayer */.qu)("click", {
                                        id: id,
                                        name: "".concat(title, " с ").concat(dateStart, " по ").concat(dateEnd),
                                        brand: company,
                                        category: "".concat(sea ? "Море" : "Река", "/").concat(categoryTitle, "/").concat(title, "/").concat(route),
                                        list: popdir === null || popdir === void 0 ? void 0 : popdir.caption,
                                        position: index + 1,
                                        price: price,
                                        quantity: 1
                                    }),
                                    metriks && isClient/* isClient */.C && window.ym(35441960, "reachGoal", metriks), 
                                ];
                            },
                            children: popularCruises ? "Подробнее" : "Выбор каюты"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Anchor */.e, {
                        decoration: "none",
                        className: (card_module_default()).shipButton,
                        href: "/ships/".concat(link),
                        onClick: onClick !== null && onClick !== void 0 ? onClick : function() {
                            return (0,YaAndGaHelper/* YaAndGaMainPage */.gh)("click_more_you_might_like");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (card_module_default()).btn,
                            children: "Подробнее"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
                size: "xmd",
                isOpen: routeModalIsOpen,
                onOpen: setRouteModalIsOpen,
                title: title || "-",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (card_module_default()).modalWrapper,
                    children: [
                        !isShipCard && dateStart && dateEnd && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (card_module_default()).modalTravelTime,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelTime/* TravelTime */.R, {
                                start: dateStart,
                                end: dateEnd,
                                days: days,
                                nights: night
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (card_module_default()).modalMap,
                            children: routeModalIsOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(CruiseRouteMap, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CruiseRoute, {
                            items: route,
                            noReturn: start !== end
                        }),
                        discounts != null && Object.values(discounts).map(function(discount) {
                            return discount != null && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (card_module_default()).modalDiscount,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                            name: "promo/sale",
                                            width: 20,
                                            height: 20
                                        }),
                                        rightGap: 8,
                                        title: "Скидка"
                                    }),
                                    discount.value,
                                    "% ",
                                    discount.alias
                                ]
                            }, discount.value);
                        }),
                        cashback === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (card_module_default()).modalBonus,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                        name: "promo/cashback",
                                        width: 24,
                                        height: 24
                                    }),
                                    rightGap: 8,
                                    title: "Иконка кэшбека"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Кэшбэк 20%"
                                })
                            ]
                        }),
                        specialNote && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (card_module_default()).modalBonus,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* Icon */.J, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                                        name: "promo/note",
                                        width: 24,
                                        height: 24
                                    }),
                                    rightGap: 8,
                                    title: "Спец предложение"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: specialNote
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                            className: (card_module_default()).modalFooter,
                            children: [
                                !isShipCard && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (card_module_default()).footerPrice,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (card_module_default()).price,
                                            children: sea && price < 200 ? "цена по запросу" : "от ".concat((0,formatter/* formatter */.z)(price), " ₽")
                                        }),
                                        oldPrice !== price && !isFavorities && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (card_module_default()).price,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (card_module_default()).oldPrice,
                                                children: sea && !price && oldPrice < 200 ? "цена по запросу" : "от ".concat((0,formatter/* formatter */.z)(oldPrice), " ₽")
                                            })
                                        })
                                    ]
                                }),
                                !isShipCard && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: href,
                                        className: url === "black_friday" ? (card_module_default()).btnBf : (card_module_default()).btn,
                                        onClick: onClick !== null && onClick !== void 0 ? onClick : function() {
                                            return [
                                                (0,YaAndGaHelper/* YaAndGaMainPage */.gh)("click_choose_cabin"),
                                                metriks && isClient/* isClient */.C && window.ym(35441960, "reachGoal", metriks), 
                                            ];
                                        },
                                        children: popularCruises ? "Подробнее" : "Выбор каюты"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
});

;// CONCATENATED MODULE: ./components/Card/index.js



/***/ }),

/***/ 49028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classcat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83840);
/* harmony import */ var _image_module_sass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52851);
/* harmony import */ var _image_module_sass__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_image_module_sass__WEBPACK_IMPORTED_MODULE_5__);






var Image = function(_param) /*#__PURE__*/ {
    var src = _param.src, srcSet = _param.srcSet, alt = _param.alt, width = _param.width, height = _param.height, size = _param.size, _media = _param.media, media = _media === void 0 ? "500px" : _media, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "src",
        "srcSet",
        "alt",
        "width",
        "height",
        "size",
        "media"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
        children: [
            srcSet && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                srcSet: "".concat(srcSet),
                type: "image/webp"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                src: "".concat(src),
                alt: alt,
                className: (0,classcat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
                    (_image_module_sass__WEBPACK_IMPORTED_MODULE_5___default().root),
                    (_image_module_sass__WEBPACK_IMPORTED_MODULE_5___default())[size]
                ]),
                width: size ? "100%" : "".concat(width, "px"),
                height: size ? "100%" : "".concat(height, "px")
            }, props))
        ]
    });
};
Image.defaultProps = {
    src: "",
    srcSet: "",
    alt: "",
    width: 300,
    height: 300,
    size: "cover"
};


/***/ }),

/***/ 178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* reexport safe */ _Modal__WEBPACK_IMPORTED_MODULE_0__.u; }
/* harmony export */ });
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31735);



/***/ }),

/***/ 7824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* reexport */ TravelTime; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classcat/index.js
var classcat = __webpack_require__(83840);
// EXTERNAL MODULE: ./components/TravelTime/traveltime.module.sass
var traveltime_module = __webpack_require__(42517);
var traveltime_module_default = /*#__PURE__*/__webpack_require__.n(traveltime_module);
;// CONCATENATED MODULE: ./components/TravelTime/TravelTime.jsx





// import { IconSVG } from '../SpriteSVG';
// import { Icon } from '../Icon';
// import { YaAndGaCruisePage } from '../../lib/YaAndGaHelper';
var TravelTime = function(param) {
    var start = param.start, end = param.end, days = param.days, nights = param.nights, className = param.className, size = param.size, startTime = param.startTime, endTime = param.endTime, // url,
    // ownerId,
    isMoscow = param.isMoscow;
    var formatDays = "".concat(days, " дн.");
    var formatNights = "".concat(nights !== null && nights !== void 0 ? nights : days - 1, " нч.");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,classcat/* default */.Z)([
            (traveltime_module_default()).wrapper,
            (traveltime_module_default())[size],
            (0,_define_property/* default */.Z)({}, className, !!className), 
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (traveltime_module_default()).dates,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: start
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: startTime && startTime !== "00:00" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (traveltime_module_default()).time,
                                    children: [
                                        startTime,
                                        !isMoscow && " (местное)"
                                    ]
                                })
                            })
                        ]
                    }),
                    "-",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "".concat(end)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: endTime && endTime !== "00:00" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (traveltime_module_default()).time,
                                    children: [
                                        endTime,
                                        !isMoscow && " (местное)"
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (traveltime_module_default()).days,
                children: [
                    days && formatDays,
                    " / ",
                    (nights || days) && formatNights
                ]
            })
        ]
    });
};
TravelTime.defaultProps = {
    className: null,
    nights: null,
    size: "default"
};

;// CONCATENATED MODULE: ./components/TravelTime/index.js



/***/ }),

/***/ 21471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useEmblaSlider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var embla_carousel_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25585);
/* harmony import */ var embla_carousel_autoplay__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22074);




var useEmblaSlider = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        loop: false,
        skipSnaps: false
    }, isAutoplay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var autoplay = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)((0,embla_carousel_autoplay__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        delay: 5000
    }, function(emblaRoot) {
        return emblaRoot.parentElement;
    }));
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), current = ref[0], setCurrent = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,embla_carousel_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(options, isAutoplay ? [
        autoplay.current
    ] : undefined), 2), ref2 = ref1[0], embla = ref1[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), prevBtnEnabled = ref3[0], setPrevBtnEnabled = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), nextBtnEnabled = ref4[0], setNextBtnEnabled = ref4[1];
    var scrollPrev = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return embla && embla.scrollPrev();
    }, [
        embla
    ]);
    var scrollNext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return embla && embla.scrollNext();
    }, [
        embla
    ]);
    var onSelect = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (!embla) return;
        setCurrent(embla.selectedScrollSnap());
        setPrevBtnEnabled(embla.canScrollPrev());
        setNextBtnEnabled(embla.canScrollNext());
    }, [
        embla,
        current
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!embla) return;
        onSelect();
        embla.on("select", onSelect);
    }, [
        embla,
        onSelect
    ]);
    var onSelectSlide = function(index) {
        embla.scrollTo(index);
    };
    return {
        ref: ref2,
        current: current,
        onSelectSlide: onSelectSlide,
        scrollPrev: scrollPrev,
        scrollNext: scrollNext,
        prevBtnEnabled: prevBtnEnabled,
        nextBtnEnabled: nextBtnEnabled
    };
};


/***/ }),

/***/ 13866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ sendVKPixelEvent; }
/* harmony export */ });
var sendVKPixelEvent = function(goal, params) {
    if ( false || !window._tmr) return;
    var product_id = params.product_id, value = params.value;
    window._tmr.push({
        type: "reachGoal",
        id: 3320999,
        value: value !== null && value !== void 0 ? value : 0,
        goal: goal,
        params: {
            product_id: product_id
        }
    });
};


/***/ }),

/***/ 31181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ ReworkUrl; }
/* harmony export */ });
// export const ReworkUrl = (url) => typeof url === 'string' && url.startsWith("https://kruiz.online")
//   ? url?.replace("https://kruiz.online", '')
//   : url?.replace("https://sea.z.tech", '');
var ReworkUrl = function(url) {
    if (typeof url !== "string") return null;
    var isProd = url.startsWith("https://kruiz.online");
    if (isProd) return url;
    if (url.startsWith("/")) return "https://kruiz.online".concat(url);
    return url.replace("https://sea.z.tech", "");
};


/***/ }),

/***/ 14971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fc": function() { return /* binding */ formatDateEnd; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "yk": function() { return /* binding */ formatDateStart; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10285);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_locale_ru__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70600);
/* harmony import */ var dayjs_locale_ru__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_ru__WEBPACK_IMPORTED_MODULE_2__);



var formatDateStart = function(dateStart, dateEnd) {
    var dateYear = Number(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateStart).format("YYYY"));
    var dateEndYear = Number(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateEnd).format("YYYY"));
    var start = function(date) {
        if (date !== dateEndYear) {
            return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateStart).format("DD MMMM YYYY");
        }
        return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateStart).format("DD MMMM");
    };
    return start(dateYear);
};
var formatDateEnd = function(dateEnd, isCruise) {
    var thisYear = Number(dayjs__WEBPACK_IMPORTED_MODULE_0___default()().format("YYYY"));
    var dateYear = Number(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateEnd).format("YYYY"));
    var start = function(date) {
        if (date !== thisYear) {
            if (isCruise) {
                return "".concat(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateEnd).format("DD MMMM YYYY"), " года");
            }
            return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateEnd).format("DD MMMM YYYY");
        }
        return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateEnd).format("DD MMMM");
    };
    return start(dateYear);
};
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().locale("ru");
var formatDate = function(dateString) {
    var parsedDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateString, "DD.MM.YYYY");
    if (!parsedDate.isValid()) {
        throw new Error("Неверный формат даты");
    }
    return parsedDate.format("DD MMMM");
};


/***/ }),

/***/ 75829:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"card_wrapper__X0ZPg","link":"card_link__CT9JZ","percent":"card_percent__Dz3Fv","footerPrice":"card_footerPrice__WLZQj","shipButton":"card_shipButton__okxOR","main":"card_main__1buXf","header":"card_header__8rel_","badgeRight":"card_badgeRight__YP0S0","favorite":"card_favorite__S5Wjq","pic":"card_pic__Oxz3y","company":"card_company__aGfWB","blackout":"card_blackout__MvUNs","badges":"card_badges__3bJTW","bagesBlock":"card_bagesBlock__uu67v","dots":"card_dots__iGg68","dot":"card_dot__upBIQ","active":"card_active__Ca9lr","morePhotos":"card_morePhotos__smNIX","embla":"card_embla__3krKQ","emblaContainer":"card_emblaContainer__6p33X","emblaSlide":"card_emblaSlide__mtSfd","zones":"card_zones__r_wh2","zone":"card_zone__r6s8C","viewed":"card_viewed__Pbwt_","body":"card_body__9d8Z_","time":"card_time__CDVcb","bonus":"card_bonus__BcUMu","discount":"card_discount__M2HMI","footer":"card_footer__uyZ11","price":"card_price__2kzpO","priceInfo":"card_priceInfo__rpMcE","oldPrice":"card_oldPrice__MwgO3","btn":"card_btn__G5DiG","btnBf":"card_btnBf__xJ5f_","modalDiscounts":"card_modalDiscounts__CDP2S","modalWrapper":"card_modalWrapper__iyMJh","modalMap":"card_modalMap__HVQS6","modalTravelTime":"card_modalTravelTime__Siq_4","modalDiscount":"card_modalDiscount___D0zN","modalBonus":"card_modalBonus__sb2q_","modalFooter":"card_modalFooter__zqhVO"};

/***/ }),

/***/ 31127:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"noReturn":"cruiseroute_noReturn__Ja9YU","bold":"cruiseroute_bold__wH5vA","btn":"cruiseroute_btn__F3GNK"};

/***/ }),

/***/ 52851:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"image_root__lPXxH","none":"image_none__MXx4v","cover":"image_cover__iOpfP","fill":"image_fill__BMPWp","contain":"image_contain__tYnQv"};

/***/ }),

/***/ 42517:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"traveltime_wrapper__hI5VA","dates":"traveltime_dates__sj_xJ","days":"traveltime_days__aoX9W","time":"traveltime_time__zIMfU","default":"traveltime_default__pzBr4","lg":"traveltime_lg__75snk"};

/***/ })

}]);